import React from 'react';

interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  fullWidth?: boolean;
}

const Input: React.FC<InputProps> = ({
  label,
  error,
  fullWidth = true,
  className = '',
  ...props
}) => {
  const baseClasses = 'px-4 py-2 border border-gray-300 rounded-lg !text-sm focus:outline-none focus:ring-2 focus:ring-purle-700 focus:border-transparent';
  const errorClasses = error ? 'border-red-300 focus:ring-red-500' : '';
  const widthClass = fullWidth ? 'w-full' : '';

  const classes = `${baseClasses} ${errorClasses} ${widthClass} ${className}`;

  return (
    <div className={fullWidth ? 'w-full' : ''}>
      {label && (
        <label className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <input className={classes} {...props} />
      {error && (
        <p className="mt-1 text-sm text-red-600">{error}</p>
      )}
    </div>
  );
};

export default Input;
